import { ApiClient, type AutoItTestResultDto } from "../../types/domainobjects";
import type { AutoItTestForm } from "../types/autoit-test-form";

const apiClient = new ApiClient();

export const testAutoItCredentials = async (
  form: AutoItTestForm,
): Promise<AutoItTestResultDto> => {
  return await apiClient.autoItTest_TestCredentials({
    clientId: form.clientId,
    clientSecret: form.clientSecret,
    enterpriseId: form.enterpriseId,
    companyId: form.companyId || undefined,
  });
};
